<template>
  <div class="allCards">
    <h2>{{ heading }}</h2>

    <transition-group name="fake-isotope">
      <Card
        v-for="action in pageItems"
        :key="`${action[':id']}`"
        :title="action.title"
        :description="action.description"
        :date="action.years_range"
        :id="action[':id']"
        :link="action.route"
      />
    </transition-group>

    <div id="noCards" v-if="cards.length == 0">
      Sorry, there are no actions that match your filters. Try again or 
      <a @click="$emit('clear')">clear your filters</a>.
    </div>

    <Pagination 
      :page="page"
      :pageQuantity="pageQuantity"
    />
  </div>
</template>

<script>
import Card from "@/components/Card.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "CardSet",
  props: {
    cards: Array,
    heading: String,
    page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      perPage: 18,
    };
  },
  computed: {

    pageQuantity() {
      return Math.ceil(this.cards.length / this.perPage);
    },
    start() {
      return (this.page - 1) * this.perPage;
    },
    end() {
      return this.start + this.perPage;
    },
    pageItems() {
      return this.cards.slice(this.start, this.end);
    },
  },
  components: {
    Card,
    Pagination
  },
};
</script>

<style lang="scss">
  .fake-isotope-enter-active,
  .fake-isotope-leave-active {
    transition: all 0.4s ease-in-out;
  }

  .fake-isotope-enter-from,
  .fake-isotope-leave-to {
    opacity: 0;
    transform: scale(0);
    position:absolute;
  }

  #noCards {
    padding:0 10px;

    a {
      font-weight: bold;
      cursor: pointer;

      &:hover {
        color: #003da5;
      }
    }
  }
</style>

<style lang="scss" scoped>
 h2 {
  margin-left:5px;

  @media (max-width:991px){
    display:none;
  }
 }
</style>